import {RequestAuthorizationPayload } from "../models/RequestAuthorization";
import API from "./api";

export const RequestAuthorization = (configUrl: string, payload: RequestAuthorizationPayload) => API.postApi(`${configUrl}api/requestReferral`,payload)